<template>
  <el-dialog :visible.sync="modelVisible" title="驳回原因" width="500px" :close-on-click-modal="false">
    <el-form ref="form" :model="formState">
      <el-form-item
        prop="reason"
        :rules="[
          { required: true, message: '请输入驳回原因', trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="formState.reason" type="textarea" maxlength="100" :rows="8" placeholder="请输入驳回原因" size="medium" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="footer_buttons">
        <el-button @click="handleCancel">
          取消
        </el-button>
        <el-button type="primary" @click="handleSubmit">
          确认
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'RejectPopup',
  emits: ['reject', 'update:visible'],
  model: {
    prop: 'visible',
    event: 'update:visible'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formState: {
        reason: ''
      }
    };
  },
  computed: {
    modelVisible: {
      get () {
        return this.visible;
      },
      set (val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('reject', this.formState);
        }
      });
    },
    handleCancel () {
      // 重置表单
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.modelVisible = false;
    }
  }
};
</script>
<style scoped lang="scss">
:deep(.el-dialog__body) {
  padding: 20px 20px 2px 20px;
  border-bottom: 1px solid #ebeef5;
}
.footer_buttons {
  :deep(.el-button) {
    font-size: 16px;
    width: 120px;
    height: 42px;
    & + .el-button {
      margin-left: 18px;
    }
  }
}
:deep(.el-form-item__error) {
  font-size: 14px;
}
</style>
